import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable } from 'rxjs';
import { WorkerGroup } from '../models';
import { Cookies } from 'typescript-cookie';

@Injectable({
  providedIn: 'root',
})
export class UserGroupService {
  private apiService = inject(ApiService);

  storeUserGroup(data: WorkerGroup, businessId: number) {
    return this.apiService.store(
      `workerGroup?name=${data.name}&description=${data.description}&business_id=${businessId}`,
      undefined
    );
  }

  deleteUserGroup(id: number) {
    return this.apiService.delete(`workerGroup`, id);
  }

  getUserGroups(businessId?: number): Observable<any> {
    if (businessId) {
      return this.apiService.getAll(`workerGroup?business_id=${businessId}`);
    } else {
      const business = Cookies.get(`bussinesId`);
      return this.apiService.getAll(`workerGroup?business_id=${business}`);
    }
  }

  getUserGroup(id: number): Observable<any> {
    return this.apiService.getById(`workerGroup`, id);
  }

  updateUserGroup(data: WorkerGroup, id: number, business_id?: number) {
    return this.apiService.update(
      `workerGroup/${id}?name=${data.name}&description=${data.description}&business_id=${business_id}`,
      '',
      id
    );
  }

  getUserGroupsbybussiness(business: string): Observable<any> {
    return this.apiService.getAll(`workerGroup?business_id=${business}`);
  }
}
